<template>
  <div class="u-pad-v--4 u-fg--black">
    <template v-if="state === 'success'">
      <div class="o-container o-container--responsive">
        <div class="o-layout o-layout--responsive">
          <div class="o-layout__item u-mrgn-top--2">
            <Breadcrumb :this-page="thisPage" :other-links="otherBreadcrumbLink" />
          </div>
        </div>
        <div><ProductHeader :product="product" /></div>

        <div class="u-mrgn-bottom--4">
          <div class="o-layout o-layout--responsive">
            <div class="o-layout__item" style="width: 55%">
              <div class="c-panel">
                <ProductInfo
                  :asset-allocation-date="assetAllocationDate"
                  :asset-allocation="product.asset_allocation"
                  :launch-date="product.launch_date"
                  :custodian-bank-name="product.custodian_bank_name"
                  :subscription-limit="product.subscription_limit"
                  :next-subscription-limit="product.next_subscription_limit"
                  :investment-goals="product.investment_goals"
                  :prospectus-url="product.prospectus_url"
                  :fund-fact-sheet-url="product.factsheet_url"
                  :syariah="product.syariah"
                />
              </div>
            </div>
            <div class="o-layout__item u-pad-left--4" style="width: 45%">
              <div class="c-panel u-mrgn-bottom--4">
                <div class="c-panel__body">
                  <div class="u-mrgn-bottom--4">
                    <ReturnHistory :return-title="returnTitle" :return-data="returnData" />
                  </div>
                  <ProductChart
                    :product="product"
                    :show-bottom-range-selector="true"
                    title="Grafik Perubahan Harga"
                    chart-height="200px"
                  />
                  <a
                    class="c-btn c-btn--medium c-btn--red c-btn--block qa-product-detail__subscribe-btn"
                    @click.prevent="goToBuyPage"
                  >
                    Beli Sekarang
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div><OtherLinkFooter :other-links="otherLinks" /></div>
      </div>
    </template>
    <template v-if="state === 'error'">
      <div class="o-container o-container--full u-mrgn-top--3 u-txt--medium">
        Gagal memuat data, <a @click="getProduct">muat ulang</a>
      </div>
    </template>
    <template v-if="state === 'loading'">
      <LoadingSpinner is-desktop />
    </template>
  </div>
</template>

<script>
import ProductChart from 'shared/components/ProductChart';
import ReturnHistory from 'shared/components/desktop/ReturnHistory';
import OtherLinkFooter from 'shared/components/desktop/OtherLinkFooter';
import ProductInfo from 'shared/components/desktop/ProductInfo';
import ProductHeader from 'shared/components/desktop/ProductHeader';
import LoadingSpinner from 'shared/components/LoadingSpinner';
import Breadcrumb from 'shared/components/desktop/Breadcrumb';

export default {
  name: 'ProductDetailDesktop',
  components: {
    OtherLinkFooter,
    LoadingSpinner,
    ReturnHistory,
    ProductChart,
    Breadcrumb,
    ProductInfo,
    ProductHeader,
  },
  props: {
    otherLinks: {
      type: Array,
      default: () => [],
    },
    state: {
      type: String,
      default: 'loading',
    },
    product: {
      type: Object,
      default: () => ({}),
    },
    returnTitle: {
      type: Array,
      default: () => [],
    },
    returnData: {
      type: Array,
      default: () => [],
    },
    assetAllocationDate: {
      type: String,
      default: '',
    },
    breadcrumbLinks: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    thisPage() {
      return this.breadcrumbLinks.find(link => link.isActive);
    },
    otherBreadcrumbLink() {
      return this.breadcrumbLinks.filter(link => !link.isActive);
    },
  },
  methods: {
    getProduct() {
      this.$emit('getProduct');
    },
    goToBuyPage() {
      this.$emit('goToBuyPage');
    },
  },
};
</script>
